import { AdvancedMarker } from '@vis.gl/react-google-maps';
import { useCallback } from 'react';
import MarkerMultiple from '~/assets/images/marker-multi-practitioner.svg?react';
import MarkerSolo from '~/assets/images/marker-solo-practitioner.svg?react';
import cn from 'classnames';
import { SearchResultGroupByLocation } from '~/utilities/types';
import { Marker as MarkerType } from '@googlemaps/markerclusterer';
import { MarkerInfoWindow } from './MarkerInfoWindow';
import { useView } from '~/hooks';

interface MarkerProps {
  result: SearchResultGroupByLocation;
  anchor: MarkerType | null;
  setMarkerRef: (marker: MarkerType | null, key: string) => void;
  isSelected: boolean;
  handleMarkerClick: (
    isMultiple: boolean,
    result: SearchResultGroupByLocation
  ) => void;
}

export const Marker = ({
  result,
  anchor,
  setMarkerRef,
  isSelected,
  handleMarkerClick,
}: MarkerProps) => {
  const { isMobile } = useView();
  const { clinicLocationGuid, locationCoordinates, practitioners } = result;

  const isMultiple = practitioners.length > 1;

  //ref to track markers in the parent's state
  const ref = useCallback(
    (marker: google.maps.marker.AdvancedMarkerElement) =>
      setMarkerRef(marker, clinicLocationGuid),
    [setMarkerRef, clinicLocationGuid]
  );

  const markerClassNames = cn(
    'duration-300',
    'ease-in-out',
    'hover:scale-125',
    {
      'scale-125': isSelected,
    }
  );

  return (
    <AdvancedMarker
      data-testid="marker"
      position={{
        lat: locationCoordinates.latitude,
        lng: locationCoordinates.longitude,
      }}
      ref={ref}
      key={clinicLocationGuid}
      onClick={() => handleMarkerClick(isMultiple, result)}
    >
      {isSelected && !isMobile && (
        <MarkerInfoWindow {...result} anchor={anchor} />
      )}
      {isMultiple ? (
        <MarkerMultiple className={markerClassNames} />
      ) : (
        <MarkerSolo className={markerClassNames} />
      )}
    </AdvancedMarker>
  );
};
